import React, { useEffect, useState, useCallback } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import InputMonto from '../../components/InputMonto';
import { money, moneyK, fecha, hoy, Title, Empty } from './ui';
import RangoFechas, { rangoInicial } from '../../components/RangoFechas';

export default function AgenciaEgresos() {
  const [data, setData] = useState({ egresos: [], por_categoria: [], total: 0 });
  const [rango, setRango] = useState(() => rangoInicial('actual'));
  const [f, setF] = useState(() => { const r = rangoInicial('actual'); return { desde: r.desde, hasta: r.hasta, categoria: '' }; });
  const [listas, setListas] = useState({ medios: [], categorias: [] });
  const [nuevo, setNuevo] = useState(null);

  const load = useCallback(() => { api.get('/agency/egresos', { params: f }).then(r => setData(r.data)).catch(() => {}); }, [f]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { api.get('/agency/listas').then(r => setListas(r.data)).catch(() => {}); }, []);

  const crear = async (e) => {
    e.preventDefault();
    try { await api.post('/agency/egresos', nuevo); toast.success('Egreso cargado'); setNuevo(null); load(); }
    catch { toast.error('Error'); }
  };
  const borrar = async (id) => {
    if (!window.confirm('¿Eliminar este egreso?')) return;
    try { await api.delete('/agency/egresos/' + id); load(); } catch { toast.error('Error'); }
  };

  const th = { textAlign: 'left', fontSize: 11, color: 'var(--text-muted)', fontWeight: 700, padding: '8px' };
  const td = { padding: '10px 8px', borderTop: '1px solid var(--border)', fontSize: 13 };
  const CATEGORIAS = [...new Set([...(listas.categorias || []), 'Inversión publicitaria', 'Colaboradores', 'Comisiones a agencias', 'Servicios e infraestructura', 'Impuestos', 'Otros gastos'])];

  return (
    <div>
      <Title right={<button className="btn btn-primary" onClick={() => setNuevo({ fecha: hoy(), categoria: 'Otros gastos', monto: '' })}><Plus size={16} /> Nuevo egreso</button>}>Egresos</Title>

      {/* El mismo selector de período que el resto de las pantallas */}
      <RangoFechas valor={rango} onChange={r => { setRango(r); setF({ ...f, desde: r.desde, hasta: r.hasta }); }}
        derecha={<span style={{ fontSize: 13, whiteSpace: 'nowrap' }}>Total: <b>{moneyK(data.total)}</b></span>} />

      <div className="card" style={{ marginBottom: 16, padding: '10px 12px', display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <select value={f.categoria} onChange={e => setF({ ...f, categoria: e.target.value })} style={{ width: 'auto', fontSize: 13 }}>
          <option value="">Todas las categorías</option>
          {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      {data.por_categoria.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: 12, marginBottom: 16 }}>
          {data.por_categoria.map(c => (
            <div key={c.categoria} className="card card-dato" style={{ padding: '12px 14px' }}>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600 }}>{c.categoria}</div>
              <div style={{ fontSize: 20, fontWeight: 800, marginTop: 2 }}>{moneyK(c.total)}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{c.cant} movimientos</div>
            </div>
          ))}
        </div>
      )}

      <div className="card" style={{ padding: 0 }}>
        <div className="table-container">
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Fecha</th><th style={th}>Categoría</th><th style={th}>Proveedor / detalle</th><th style={th}>Medio</th><th style={{ ...th, textAlign: 'right' }}>Monto</th><th style={th}></th></tr></thead>
            <tbody>
              {data.egresos.length === 0 ? <tr><td colSpan={6} style={td}><Empty>Sin egresos en este período</Empty></td></tr>
                : data.egresos.map(e => (
                  <tr key={e.id}>
                    <td style={{ ...td, whiteSpace: 'nowrap' }}>{fecha(e.fecha)}</td>
                    <td style={td}>{e.categoria}</td>
                    <td style={td}><div style={{ fontWeight: 600 }}>{e.proveedor || '—'}</div>{e.descripcion && <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{e.descripcion}</div>}</td>
                    <td style={{ ...td, color: 'var(--text-muted)' }}>{e.medio || '—'}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 600, color: '#ef4444' }}>{money(e.monto)}</td>
                    <td style={td}><button className="btn btn-ghost btn-sm" onClick={() => borrar(e.id)} style={{ color: 'var(--danger)', padding: 4 }}><Trash2 size={14} /></button></td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {nuevo && (
        <div className="modal-overlay" onClick={() => setNuevo(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 440 }}>
            <h2>Nuevo egreso</h2>
            <form onSubmit={crear}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group"><label>Fecha</label><input type="date" value={nuevo.fecha} onChange={e => setNuevo({ ...nuevo, fecha: e.target.value })} required /></div>
                <div className="form-group"><label>Monto</label><InputMonto value={nuevo.monto} onChange={v => setNuevo({ ...nuevo, monto: v })} required /></div>
              </div>
              <div className="form-group"><label>Categoría</label>
                <select value={nuevo.categoria} onChange={e => setNuevo({ ...nuevo, categoria: e.target.value })}>
                  {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div className="form-group"><label>Proveedor</label><input value={nuevo.proveedor || ''} onChange={e => setNuevo({ ...nuevo, proveedor: e.target.value })} /></div>
              <div className="form-group"><label>Detalle</label><input value={nuevo.descripcion || ''} onChange={e => setNuevo({ ...nuevo, descripcion: e.target.value })} /></div>
              <div className="form-group"><label>Medio de pago</label>
                <select value={nuevo.medio_id || ''} onChange={e => setNuevo({ ...nuevo, medio_id: e.target.value })}>
                  <option value="">—</option>{listas.medios.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
                </select>
              </div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 16 }}>
                <button type="button" className="btn btn-secondary" onClick={() => setNuevo(null)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
